module.exports = __webpack_public_path__ + "img/coyote-white.5c3a5cb0.svg";